import React from 'react';
import clsx from 'clsx';
import { Label } from 'semantic-ui-react';
import CollectionsLabels from './CollectionsLabels';

const CollectionsLabelGroup = ({
  collections,
  showLogo = true,
  asLink = true,
  className,
}) => (
  <Label.Group
    className={clsx('aridhia-collections-label-group aridhia-h4 aridhia-tag', className)}
  >
    <CollectionsLabels collections={collections} showLogo={showLogo} asLink={asLink} />
  </Label.Group>
);

export default CollectionsLabelGroup;
